import debounce from '../helpers/debounce';

const POSTAL_LENGTH = 6;

/**
 * Fetch the address from the API
 * @param  {String} postal  Postal (e.g. 1234AB)
 * @param  {String} country Country abbreviation (e.g. nl)
 * @return {Promise}        jQuery promise from the ajax request
 */
function fetchAddress(postal, country) {
  return window.axios.post('/api/address-resolver', {
    postal_code: postal,
    country_code: country,
  })
    .then((res) => res.data);
}

const AddressAutofill = {
  /**
   * Initialize the events and variables
   * @param  {String} group Name of the current group
   * @return {void}
   */
  create(node) {
    this.group = node;

    // Get all elements in this group
    this.autofillPostal = this.getElementForGroup('.js-autofill-postal');
    this.autofillStreet = this.getElementForGroup('.js-autofill-street');
    this.autofillCity = this.getElementForGroup('.js-autofill-city');

    const debouncedCheck = debounce(this.runCheck.bind(this), 20);

    // Listen for changes to the postal fields
    this.autofillPostal.addEventListener('keyup', () => {
      debouncedCheck();
    });
  },

  /**
   * Get element from the same group with a classname
   * @param  {String} cls Class name to get the element for
   * @return {Node}       Element
   */
  getElementForGroup(cls) {
    return this.group.querySelector(cls);
  },

  /**
   * Small wrapper around the API call, this will handle errors and loading states
   * @return {Void}
   */
  runCheck() {
    const postal = this.autofillPostal.value.trim().replace(' ', '');
    const country = 'nl';

    // Only if the postal code seems valid, we run the check
    if (postal.length !== POSTAL_LENGTH || country === '') {
      return;
    }

    this.autofillPostal.classList.add('is-loading');

    fetchAddress(postal, country)
      .then((data) => {
        this.outputData(data);
        this.autofillPostal.classList.remove('is-loading');
      });
  },

  /**
   * Output data to the DOM, but only if the input fields are still empty
   * @param  {Object} data API object with all address information
   * @return {Void}
   */
  outputData(data) {
    if (this.autofillStreet.value === '') {
      this.autofillStreet.value = data.street;
    }

    if (this.autofillCity.value === '') {
      this.autofillCity.value = data.city;
    }
  },
};

export default AddressAutofill;
